import { createCachedSelector, defaultKeySelector, path } from '@cbridge-utils/redux';
import { NetworkStatus } from '@cbridge-utils/network';
import { alertSubscriptionStoreSelector } from '../alertSubscription.selector';

export const isSubscriptionLoading = createCachedSelector(
  [
    path(alertSubscriptionStoreSelector).processing(),
    path(alertSubscriptionStoreSelector).networkStatus(),
  ],
  (isProcessing, networkStatus) => {
    return isProcessing || (networkStatus !== NetworkStatus.Done
                   && networkStatus !== NetworkStatus.Failed);
  },
)({
  keySelector: defaultKeySelector,
});
